import { __assign, __read } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { noop } from "../_util/noop";
import { useDefault } from "../_util/use-default";
import { CheckContext } from "../check";
export function RadioGroup(_a) {
    var checkValue = _a.value, defaultCheckValue = _a.defaultValue, _b = _a.onChange, onCheckValueChange = _b === void 0 ? noop : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, type = _a.type, block = _a.block, className = _a.className, style = _a.style, children = _a.children;
    var _d = __read(useDefault(checkValue, defaultCheckValue, onCheckValueChange), 2), value = _d[0], onChange = _d[1];
    var context = {
        inject: function (checkProps) {
            // 只为 radio 提供
            if (!checkProps.radio) {
                return checkProps;
            }
            // 如果已经受控，则不注入
            if (typeof checkProps.checked === "boolean") {
                return checkProps;
            }
            var checkName = checkProps.name;
            if (typeof checkName === "undefined") {
                console.warn('<Radio> managed by <RadioGroup> must include the "name" prop');
                return checkProps;
            }
            return __assign(__assign({}, checkProps), { type: type,
                block: block, checked: value === checkProps.name, disabled: checkProps.disabled || disabled, onChange: function (checked, context) {
                    if (typeof checkProps.onChange === "function") {
                        checkProps.onChange(checked, context);
                        return;
                    }
                    if (typeof onChange === "function") {
                        onChange(checkName, context);
                    }
                } });
        },
    };
    return (React.createElement(View, { className: classNames("tea-checkbox-group", className, {
            "tea-checkbox-group--outline": type === "button",
        }), style: style },
        React.createElement(CheckContext.Provider, { value: context }, children)));
}
//# sourceMappingURL=RadioGroup.js.map